var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',[_c('OrderTemplate',{attrs:{"orders":_vm.getOrders}}),_c('div',{staticClass:"m-5 p-5"})],1),_c('MainFooter')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-5"},[_c('div',{staticClass:"p-3 px-4"},[_c('h4',{staticClass:"title is-4"},[_vm._v("My Orders")])])])
}]

export { render, staticRenderFns }